"use client";

import Link from "next/link";

import { useSettings } from "@/components/providers/SiteDataProvider";
import { icon } from "@/components/ui/icons";
import { cn } from "@/lib/ui/cn";

type SocialLinksProps = {
  className?: string;
  title?: string;
};
export function SocialLinks({ className, title }: SocialLinksProps) {
  const settings = useSettings();
  const socialLinks = settings?.socialLinks || [];

  if (socialLinks.length === 0) return null;

  return (
    <div className={cn("flex flex-col flex-wrap gap-3", className)}>
      {title && <div className="text-2xl leading-9 font-medium text-white">{title}</div>}
      <div className="flex flex-wrap gap-3">
        {socialLinks.map((social) => {
          if (!social.platform || !social.href || !social.iconName) return null;
          const label = social.label?.trim() || social.platform?.trim() || "";
          const href = social.href ?? "#";
          const isExternal = /^https?:\/\//i.test(href);

          try {
            const IconComponent = icon(social.iconName);
            return (
              <Link
                key={social._key ?? social.platform}
                href={href}
                aria-label={label || undefined}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer noopener" : undefined}
                className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white p-1 transition-colors hover:bg-emerald-400"
              >
                <IconComponent className="text-neutral-darkest h-6 w-6" />
              </Link>
            );
          } catch {
            // Fallback if icon doesn't exist
            return (
              <Link
                key={social._key ?? social.platform}
                href={href}
                aria-label={label || undefined}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer noopener" : undefined}
                className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white p-1 transition-colors hover:bg-emerald-400"
              >
                <span className="text-lg font-medium text-black">
                  {label ? label.charAt(0) : (social.platform?.charAt(0) ?? "·")}
                </span>
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}
